import React, { useState, useEffect } from 'react';
import { IoMdClose } from "react-icons/io";
import axios from 'axios';
import './DescriptionEdit.css';

const DescriptionEdit = ({ onClose }) => {
    const [description, setDescription] = useState("");
    const [jobId, setJobId] = useState(null);

    useEffect(() => {
        const storedJob = JSON.parse(localStorage.getItem('job'));
        setJobId(storedJob.jobId);
    }, []);

    useEffect(() => {
        if (jobId) {
            fetchJobDetails(jobId);
        }
    }, [jobId]);

    const fetchJobDetails = async (id) => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/fetch/job/details`, { job_id: id });
            console.log(response);

            if (response.data.result.status === 'success') {
                setDescription(response.data.result.job.description);
            } else {
                console.error(response.data.result.message);
            }
        } catch (error) {
            console.error('Error fetching job details:', error);
        }
    };

    const handleDescriptionChange = (e) => {
        setDescription(e.target.value);
    };

    const handleSaveButton = async () => {
        const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/job/update`, {
            job_id: jobId,
            description: description,
        }, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        console.log(response);


        if (response.data.result.status === 'success') {
            onClose();
        } else {
            alert('Error updating job details: ' + response.data.result.message);
        }
    };

    return (
        <div className="job-description-edit-popup-main">
            <div className="job-description-edit-popup">
                <IoMdClose className="description-edit-pop-close" onClick={onClose} />
                <section className="description-section">
                    <div className="description-input">
                        <label htmlFor="description">Describe what you need</label>
                        <textarea
                            id="description"
                            placeholder="Describe"
                            value={description}
                            onChange={handleDescriptionChange}
                        />
                    </div>
                    <div>
                        <button className="save-btn" onClick={handleSaveButton}>Save</button>
                    </div>
                </section>
            </div >
        </div>
    )
}

export default DescriptionEdit;